import React from "react";

/* Cut gem — the Membership page mark. */
export const GemIcon = ({ size = 30, fill = "var(--gem-fill)", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M6 3h12l3 5-9 13L3 8Z" fill={fill} />
    <path d="M3 8h18M9 3 7 8l5 13M15 3l2 5-5 13" />
  </svg>
);

export default GemIcon;
